import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getDivisoes } from "./services"

export const actionGetDivisoes: any = createAsyncThunk(
  "GET_DIVISÕES",
  async () => {
    const { data } = await getDivisoes()
    return data
  }
)

const divisoesSlices = createSlice({
  name: "GET_DIVISÕES",
  initialState: {
    divisaoSelected: null,
    divisoes: [],
    feedbackError: "",
    status: "",
  },
  reducers: {
    actionSelectDivisao: (state, { payload }) => {
      state.divisaoSelected = payload
    },
  },
  extraReducers: {
    [actionGetDivisoes.pending]: (state) => {
      state.status = "loading"
    },
    [actionGetDivisoes.fulfilled]: (state, action) => {
      state.status = "success"
      state.divisoes = action.payload
    },
    [actionGetDivisoes.rejected]: (state, payload) => {
      state.status = "failed"
      state.feedbackError = "Deu erro"
    },
  }
})

export default divisoesSlices.reducer
export const { actionSelectDivisao } = divisoesSlices.actions